import { useState, useContext, useEffect } from 'react';
import PropTypes from '@squiz/xaccel-prop-types';
import AssistedInputContext from '../AssistedInputContext';
function useItemGenerator(_ref) {
  let {
    id,
    generateItem,
    inputValue,
    onSubmit
  } = _ref;
  const [items, setItems] = useState([]);
  const {
    registerChildIds,
    activeDescendant,
    onInputChange
  } = useContext(AssistedInputContext);
  const [generatedItems, setGeneratedItems] = useState();
  const setInputValue = _ref2 => {
    let {
      value,
      closeAssist
    } = _ref2;
    onInputChange({
      currentTarget: {
        value
      },
      closeAssist: closeAssist !== false
    });
  };
  const generateItems = () => {
    const childIds = []; // Keep track of the child is being created
    const children = items.map((data, index) => {
      const itemConfig = {
        parentId: id,
        // Provide parent id to allow unique ids / keys to be generated
        index,
        // Provide the index as a last option fallback for unique ids
        isActive: false,
        // Is the item the activeDescendant, need to generate first to get the id to compare and find out
        data,
        // Data payload from the AssistedInputSource
        setInputValue,
        // Function to set the input value for the items onClick handler
        inputValue,
        // Passing input value to highlight typed phrase
        onSubmit // Passing on Submit handler function
      };

      let item = generateItem(itemConfig);
      const itemId = item.props.id;
      if (!itemId) {
        throw new Error(`ID undefined: ${JSON.stringify(data)}`);
      }

      // If the itemId returned matches the activeDescendant
      if (itemId === activeDescendant) {
        // Re-create it with the isActive flag set to true
        // This is slightly clunky but only has to be run twice for one item in the whole component
        item = generateItem({
          ...itemConfig,
          isActive: true
        });
      }
      childIds.push(itemId); // Store the child id
      return item;
    });
    return {
      childIds,
      children
    };
  };

  // When the items change from a new request regenerate the children and record the ids back to the context
  useEffect(() => {
    const {
      childIds,
      children
    } = generateItems();
    registerChildIds(id, childIds); // Pass the child ids created back to the context for the keyboard navigation
    setGeneratedItems(children);
  }, [items]);

  // As the active child changes alter the generate items to change what is 'active'
  useEffect(() => {
    const {
      children
    } = generateItems();
    setGeneratedItems(children);
  }, [activeDescendant]);
  return {
    setItems,
    generatedItems
  };
}
useItemGenerator.propTypes = {
  id: PropTypes.string.isRequired,
  generateItem: PropTypes.func.isRequired
};
export default useItemGenerator;